<template>
    <div class="expiredToken" >
        <div class="expiredMessage">
            Your link has expired, Please Contact OneClose Support at <a href="mailto: support@oneclose.ca">support@oneclose.ca</a>
        </div>
    </div>
</template>
<script>
    export default {
        name: "ExpiredPurchaserToken"
    }
</script>
<style scoped>
    .expiredToken{
        height:100%;
        background-color:white;
    }
    .expiredMessage{
        color:black;
        text-align:center;
        padding-top: 10%;
        background-color:white;
        font-size: 1.2em;
    }
    .expiredMessage a{
        color:black;
        text-decoration: underline;
    }
    .expiredMessage a:hover{
        color:black;
        font-weight: bold;
        text-decoration: underline;
    }
</style>